import { useTranslation } from "react-i18next";
import { chooseLanguage, LANGUAGES } from "../../i18n";

/**
 * The language, always visible in the top bar (bug list BUG-009: inside the user menu it was hard to find). Each
 * button shows the language's short code and is named in full for screen readers; the user menu keeps its own copy.
 */
export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t("user.language")}
      className="flex overflow-hidden rounded-md border border-gray-300 text-xs"
    >
      {LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          lang={lng}
          aria-pressed={i18n.resolvedLanguage === lng}
          title={t(`language.${lng}`)}
          onClick={() => chooseLanguage(lng)}
          className="px-2 py-1 font-medium uppercase text-gray-800 hover:bg-gray-100 aria-pressed:bg-brand aria-pressed:text-brand-trace"
        >
          <span aria-hidden="true">{lng}</span>
          <span className="sr-only">{t(`language.${lng}`)}</span>
        </button>
      ))}
    </div>
  );
}
